<template>
  <v-app style="background: transparent;">
    <app-top-bar v-if="!isPopup" />
    <app-drawer
      name="notifications"
      :app="true"
      :right="true"
      :clipped="false"
      :fixed="true"
      :scroll="false"
      :temporary="true"
    />
    <v-main>
      <transition name="fade" mode="out-in">
        <component :is="layout">
          <router-view />
        </component>
      </transition>
      <app-snackbar />
    </v-main>

    <app-loading-modal />
    <vue-snotify />

    <v-footer class="pa-0 position: fixed; bottom: 5px; width: 100%;" style="background: transparent;">
      <v-row justify="center" align="center" no-gutters>
        <v-col class="text-center justify-content-center" cols="auto">
          <v-row justify="center" align="center" no-gutters>
            <v-col cols="auto" class="pt-1 mr-1">
              <img
                v-if="darkMode"
                src="@/assets/images/dinamo_pb_icon_dark.png"
                height="16px"
                width="16px"
              >

              <img
                v-else
                src="@/assets/images/dinamo_pb_icon_light.png"
                height="16px"
                width="16px"
              >
            </v-col>

            <v-col class="text-center justify-content-center" cols="auto">
              <span class="grey--text text-caption text-center hide-in-percy mr-2">
                Dinamo Networks
              </span>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="text-center justify-content-center" cols="auto">
          <span class="grey--text text-caption text-center hide-in-percy mr-2">
            v. {{ fwVersion }} - {{ version }}
          </span>

          <router-link v-if="isLogged" to="/about">
            <span class="grey--text text-caption text-center hide-in-percy mr-2">
              {{ $t('about') }}
            </span>
          </router-link>
        </v-col>
        <v-col cols="auto">
          <language-radio-group />
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import AppSnackbar from '@/components/AppSnackbar'
import AppToast from '@/components/ui/AppToast'
import AppLoadingModal from '@/components/ui/AppLoadingModal'
import AppTopBar from '@/components/AppTopBar'
import AppDrawer from '@/components/drawers/AppDrawer'
import LanguageRadioGroup from '@/components/LanguageRadioGroup.vue'

export default {
  components: {
    AppToast,
    AppLoadingModal,
    AppTopBar,
    AppSnackbar,
    AppDrawer,
    LanguageRadioGroup
  },
  computed: {
    mainDrawerIsMini () {
      return this.$store.state.drawers.mainIsInMiniVariant
    },
    isLogged () {
      return this.$store.state.auth.isLogged
    },
    isPopup () {
      if (this.$route.name) return this.$route.name.indexOf('popup') !== -1
      return null
    },
    layout () {
      return this.$store.state.ui.layout
    },
    locale () {
      return this.$store.state.locale.locale
    },
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    errorCount () {
      return this.$store.state.error.count
    },
    error () {
      return this.$store.state.error
    },
    isPopupEventsOrSessions () {
      const route = this.$route.path

      return route === '/popup/events' || route === '/popup/sessions'
    },
    version () {
      return this.$store.state.ui.version
    },
    fwVersion () {
      return this.$store.getters['hsm/GET_P11_INFO_PROP']('firmwareVersion')
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    },
    darkMode (val) {
      this.$vuetify.theme.dark = val
    },
    isLogged (val) {
      this.authActions({ status: val })
    },
    errorCount () {
      if (this.error.code === 401) {
        if (this.$route.meta.public !== true) {
          this.$router.push({
            name: 'login',
            query: { to: this.$route.fullPath }
          })
        }
        this.$store.dispatch('auth/doLogout')
          .catch((err) => {
            const errObj = this.$store.getters['error/getErrorObj'](err)
            if (errObj) {
              this.$notify.hsmError(errObj, err)
            } else {
              this.$notify.error({ message: err })
            }
          })
      }
    }
  },
  mounted () {
    this.$vuetify.theme.dark = this.darkMode
    this.authActions({ status: this.isLogged })
  },
  methods: {
    authActions ({ status = false }) {
      if (this.$route.meta.public !== true) {
        if (!status) {
          this.$store.commit('ui/CLEAR_ALL_INTERVALS')
          this.$router.push({ name: 'login' })
        }
      }
      if (status) {
        this.$store.dispatch('warning/load')
        setInterval(async () => {
          const perm = this.$store.getters['auth/getPermissions']
          if (perm.canUserAccessRemoteLog) {
            await this.$store.dispatch('warning/load')
          } else {
            await this.$store.dispatch('hsm/getCopyrightInfo')
          }
        }, 1 * 60 * 1000)
      }
    }
  }
}
</script>

<style lang="scss">
@import 'assets/styles/main';
</style>
